import ToolkitsSideMenuTour from '../../components/tour/ToolkitsSideMenu';
import cmsFactory from '../../components/cmsFactory';
import createComponent from '../../components/contentDisplay/dynamic';
import { createElement } from 'react';
import styles from './ToolkitNavBar.module.scss';
const ToolkitNavBar = ({
  data: {
    leftMenu,
    rightMenu
  },
  isCollapsed,
  setCollapsed
}) => <div className={styles['toolkit-nav-bar']} data-sentry-component="ToolkitNavBar" data-sentry-source-file="ToolkitNavBar.jsx">
    <div id="toolkits-left-menu" className={styles.navSection} children={leftMenu.map((item, key) => ({
    ...item,
    key,
    isCollapsed,
    setCollapsed
  })).map(createComponent)} />
    <div id="toolkits-right-menu" className={styles.navSection} children={rightMenu.map((item, key) => ({
    ...item,
    key,
    isCollapsed,
    setCollapsed
  })).map(createComponent)} />

    <ToolkitsSideMenuTour data-sentry-element="ToolkitsSideMenuTour" data-sentry-source-file="ToolkitNavBar.jsx" />
  </div>;
export default cmsFactory(ToolkitNavBar, '/content/singletons/navMenu.json');